var _line, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 67.7 67.7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "5px",
    x1: 2.5,
    x2: 65.2,
    y1: 2.5,
    y2: 65.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "5px",
    cx: 34.39,
    cy: 34.05,
    r: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m66.72 34.33a2 2 0 0 0 0-0.24 2.88 2.88 0 0 0 0-0.48 2 2 0 0 0 0-0.24 2.1 2.1 0 0 0-0.06-0.24 1.17 1.17 0 0 0-0.09-0.24v-0.15l-0.07-0.12a36.44 36.44 0 0 0-65.2 0l-0.07 0.12v0.15a1.17 1.17 0 0 0-0.09 0.24 2.1 2.1 0 0 0-0.06 0.24 2 2 0 0 0 0 0.24 2.89 2.89 0 0 0 0 0.48 2 2 0 0 0 0 0.24c0 0.08 0 0.16 0.05 0.23a1.86 1.86 0 0 0 0.1 0.25v0.15l0.06 0.11a36.43 36.43 0 0 0 65.18 0l0.06-0.11v-0.15a1.86 1.86 0 0 0 0.1-0.25c0.06-0.07 0.07-0.15 0.09-0.23zm-32.87 15.92a31.68 31.68 0 0 1-27.59-16.4 31.41 31.41 0 0 1 55.18 0 31.69 31.69 0 0 1-27.59 16.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.862df2cf.svg";
export { ForwardRef as ReactComponent };